import styled from 'styled-components';
import Severity from 'Screens/Contextualization/Host/components/Table/components/Severity';

export const Wrapper = styled.div`
  padding: 0 20px 24px 20px;
  background-color: ${({ theme }) => theme.backgrounds.detailModalFields};
`;
Wrapper.displayName = 'Wrapper';

export const ProgressBar = styled(Severity)`
  max-width: 330px;
`;
ProgressBar.displayName = 'ProgressBar';

export const EmptyState = styled.div`
  color: ${({ theme }) => theme.text.detailModalFields};
  font-size: 14px;
`;
EmptyState.displayName = 'EmptyState';
